//#region  import
import React, { Component } from "react"
import { CATEGORY } from "../../modules/constants"
import { createNexusCommitteesHeadersData } from "../../tableData/nexus/createNexusCommitteesTableHeaders"
import { createNexusCommitteesRowData } from "../../tableData/nexus/createNexusCommitteesTableRows"
import { createNexusCommitteesFootersData } from "../../tableData/nexus/createNexusCommitteesTableFooters"
import NumerableTable from "../NumerableTable"
import initStats from "./InitStats"
import NoDataMessage from "../searchCompanies/NoDataMessage"

//#endregion import

class NexusCommitteesTable extends Component {
  /*
  shouldComponentUpdate(nextProps, nextState) {
    // console.log("this.props.searchResults:",this.props.searchResults)
    // console.log("nextProps.searchResults:",nextProps.searchResults)
    return nextProps.searchString !== this.props.searchString || nextProps.searchResults !== this.props.searchResults
  }
  */
  render() {
    // console.log("CompanyCommitteesTable this.props: ", this.props)
    const { handleClickFavouriteIcon, handleSelect, items, kind, showIndex, tableAnalysis, zeroCommitteeNodes } = this.props
    const isCompany = items[0].entity.category === CATEGORY.COMPANY
    const parentName = items[0].entity.name.toPresent ?? items[0].entity.name.original
    const lseCompany = !!items[0].entity.companyProps?.lse
    const stats = initStats()
    const tableProps = { ...this.props, isCompany, lseCompany, parentName, showIndex, stats }
    return (
      <React.Fragment>
        {items?.length < 2 &&
          <NoDataMessage kind={kind} zeroCommitteeNodes={zeroCommitteeNodes} />}

        {/* items[0] is the company */}
        {items.length > 1 &&
          (<NumerableTable table={{
            ...this.props,
            headers: createNexusCommitteesHeadersData(tableProps),
            rows: createNexusCommitteesRowData(tableProps),
            footers: tableAnalysis ? createNexusCommitteesFootersData(tableProps) : null,
            handleOnClick: row => handleSelect(row.link),
            handleClickFavouriteIcon: row => handleClickFavouriteIcon(row),
          }}
          ></NumerableTable>)
        }
      </React.Fragment>
    )
  }
}

export default NexusCommitteesTable